<script setup lang="ts">
import { useSettingsStore } from '../../model/settings/store'

defineOptions({
  name: 'BannerConfigVault',
})

const settingsStore = useSettingsStore()

const configVaultUrl = computed<string | null>(() => {
  try {
    const url = new URL(settingsStore.getConfigVaultUrl)

    return url.protocol === 'https:' ? url.href : null
  } catch {
    return null
  }
})
</script>

<template>
  <div class="banner-config-vault">
    <span>
      Everything on this page is managed by the
      <a
        v-if="configVaultUrl"
        :href="configVaultUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="banner-config-vault__link"
        data-qa="config-vault-link"
      >Config Vault</a>
      <span
        v-else
        class="banner-config-vault__link"
      >Config Vault</span>
      app.
    </span>
  </div>
</template>

<style scoped lang="scss" src="./BannerConfigVault.scss" />
